import { User } from 'model';
import { FixedField } from '../../components/Forms/FixedField.js';
import { Select } from '../../components/Forms/Select.js';
import { UserItem } from '../../components/admin/UserItem.js';
import { UISuspendTimes } from '../../model/report.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
export const SuspendModal: React.FC<{
	user: User | undefined;
	setSuspendTimes: (val: string) => void;
	suspendTimes: string;
	isSuspended: boolean;
}> = ({ user, setSuspendTimes, suspendTimes, isSuspended }) => {
	return (
		<div>
			<div className={sharedStyles.userContainer}>{user && <UserItem user={user} modal={true} />}</div>
			{user && <FixedField label="Email" field={user.email} />}
			<div className="space20" />
			<h4 style={{ marginBottom: '40px' }}>
				<>
					{`Are you sure you want to ${isSuspended ? 'Unsuspend ' : 'Suspend '}`}
					<span className={sharedStyles.highlight}>{user?.username}</span>?
					{!isSuspended && (
						<>
							<div className="space20" />
							<Select
								id="reason"
								placeholder="Suspend until"
								label="Suspend until"
								value={suspendTimes}
								name="reason"
								options={UISuspendTimes}
								onChange={e => {
									setSuspendTimes(e.target.value);
								}}
							/>
						</>
					)}
				</>
			</h4>
		</div>
	);
};
